import React, { useState } from "react";

import { useTranslate } from "localization";
import { Filter } from "ui/forms";
import { Option } from "ui/forms/Filter/Menu";

interface Props {
  i18nKeyTitle: string;
  options: Option[];
  selected?: string[];
  onChange?: (value: string[]) => void;
}

export const FrontEndFilter: React.FC<Props> = (props) => {
  const { options } = props;

  const { translate } = useTranslate();
  const title = translate(props.i18nKeyTitle, { count: 1 });

  const [selected, setSelected] = useState<string[]>(props.selected ?? []);

  const onChange = (value: string[]) => {
    setSelected(value);
    props.onChange?.(value);
  };

  return (
    <Filter
      items={{ options }}
      title={title}
      label={title}
      selected={!!selected.length}
      count={selected.length ? selected.length : void 0}
      onChange={onChange}
      disabled={!options.length || !selected}
      value={selected}
      multi={true}
      showReset={true}
      showApply={true}
      searchable={true}
      translate={translate}
    />
  );
};
